import HttpHelpers from '../helpers';

const ListingsApiEndpoints = {
  createListing: () => {
    return HttpHelpers.authenticatedAxios
      .post('host/listing')
      .then((response) => response.data);
  },

  updateListing: (id, data) => {
    return HttpHelpers.authenticatedAxios
      .patch(`host/listing/${id}`, data)
      .then((response) => response.data);
  },

  updateListingEntities: (id, data) => {
    return HttpHelpers.authenticatedAxios
      .put(`host/listing/${id}/entities`, data)
      .then((response) => response.data);
  },

  uploadListingImage: (id, data) => {
    return HttpHelpers.authenticatedAxios
      .post(`host/listing/${id}/image`, data)
      .then((response) => response.data);
  },

  deleteListingImage: (id, imageId) => {
    return HttpHelpers.authenticatedAxios
      .delete(`host/listing/${id}/image/${imageId}`)
      .then((response) => response.data);
  },

  updateListingAvailability: (data) => {
    return HttpHelpers.authenticatedAxios
      .put('host/availability', data)
      .then((response) => response.data);
  },

  getHostListings: (params) => {
    return HttpHelpers.authenticatedAxios
      .get('host/listing', { params })
      .then((response) => response.data);
  },

  deleteHostListing: (listingId) => {
    return HttpHelpers.authenticatedAxios
      .delete(`host/listing/${listingId}`)
      .then((response) => response.data);
  },

  getHostListingDetails: (listingId) => {
    return HttpHelpers.authenticatedAxios
      .get(`host/listing/${listingId}`)
      .then((response) => response.data);
  },

  submitListing: (id) => {
    return HttpHelpers.authenticatedAxios
      .patch(`host/listing/${id}/submit`)
      .then((response) => response.data);
  },

  uploadPolicyFile: (id, data) => {
    return HttpHelpers.authenticatedAxios
      .post(`host/listing/${id}/file`, data)
      .then((response) => response.data);
  },

  getListingBlockTimes: (params) => {
    return HttpHelpers.authenticatedAxios
      .get('host/blocked-time', { params })
      .then((response) => response.data);
  },

  createListingBlockTime: (data) => {
    return HttpHelpers.authenticatedAxios
      .post('host/blocked-time', data)
      .then((response) => response.data);
  },

  deleteListingBlockTime: (blockTimeId) => {
    return HttpHelpers.authenticatedAxios
      .delete(`host/blocked-time/${blockTimeId}`)
      .then((response) => response.data);
  },

  getListingBookings: (id, params) => {
    return HttpHelpers.authenticatedAxios
      .get(`/host/listing/${id}/bookings`, { params })
      .then((response) => response.data);
  },

  getBookingsCalendar: (listingId, params) => {
    return HttpHelpers.authenticatedAxios
      .get(`/host/listing/${listingId}/calendar`, { params })
      .then((response) => response.data);
  },
};

export default ListingsApiEndpoints;
